module.exports = __webpack_public_path__ + "img/big.e5259b5a.svg";